import React, { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Card, CardContent, CircularProgress } from '@mui/material';
import {API_BASE_URL}  from '../../constants/constants.js'; // Adjust the import path as necessary
const DataTableListNew = () => {
  const [tables, setTables] = useState([]);
//https://www.po.sriyansh.co.in/auditreports

const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    setPageLoader(true);
    fetch(`${API_BASE_URL}/auditreports`) // Adjust the URL if needed
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setTables(data);
        } else {
          console.error('Unexpected data format:', data);
        }
        setPageLoader(false);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  // Function to render a single table
  const renderTable = (table, index) => {
    // Check if the table is a valid non-empty array
    if (!Array.isArray(table) || table.length === 0) return null;

    const firstObject = table[0];
    if (!firstObject || typeof firstObject !== 'object') return null; // Ensure the first object exists and is valid

   // const heading = Object.values(firstObject)[0]; // Extract heading from the first object's first value
   

    const heading = `${index + 1}`;


    return (

      <Card className="Formcard">








<div className="input-groupHeading">
            Audit Report Number {heading}

            </div>
        <CardContent>
      <Box key={index} mb={4}>
        {/* <Typography variant="h6" gutterBottom>
          {heading}
        </Typography> */}
        <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {Object.keys(firstObject).map((key) => (
              <TableCell
                key={key}
                sx={{
                  backgroundColor: 'black',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '16px',
                }}
              >
                {key}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {table.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {Object.values(row).map((value, colIndex) => (
                <TableCell key={colIndex}>{value || '-'}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      </Box>
      </CardContent>
      </Card>
    );
  };

  return (






    <Card className="Formcard">












      <div className="input-groupHeading">
      Audit Query Results
            </div>


 
            {pageLoader ? (
              <div className="loaderContainer">
                {" "}
                <CircularProgress />{" "}
              </div>
            ) : ( 
    <Box p={2}>
      {/* <Typography variant="h4" gutterBottom>
        Audit Results (Errors)
      </Typography> */}
     


            
      {tables.map((table, index) => renderTable(table, index))}
    
    </Box>
    )}
    </Card>
  );
};

export default DataTableListNew;
